import { useCurrentUser } from "./useCurrentUser";

/**
 * Hook para verificar se o usuário atual pode criar, editar ou excluir itens
 * Owners têm apenas permissões de visualização (read-only)
 */
export function useCanEdit() {
  const { user, loading } = useCurrentUser();

  // Se ainda está carregando, assumir que pode editar temporariamente (evita flicker)
  if (loading || !user) {
    return { canEdit: true, loading: true };
  }

  // Owner não pode criar, editar ou excluir
  const canEdit = user.role !== 'owner';

  return { canEdit, loading: false };
}

